import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPlugin2"><Path d="M4 5C4 3.89543 4.89543 3 6 3H9C10.1046 3 11 3.89543 11 5V7H4V5Z" fill="currentColor"/><Path d="M13 5C13 3.89543 13.8954 3 15 3H18C19.1046 3 20 3.89543 20 5V7H13V5Z" fill="currentColor"/><Path d="M2 10.5C2 9.11929 3.11929 8 4.5 8H19.5C20.8807 8 22 9.11929 22 10.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin2;
